import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";

import { getMyOrganizationFn } from "~/lib/functions/cco-representatives";

/** One organization the person represents; its pages share this lookup. */
export const Route = createFileRoute("/_user/my-organization/$slug")({
  staticData: { title: "Organization" },
  loader: async ({ params }) => {
    const organization = await getMyOrganizationFn({
      data: { slug: params.slug },
    });
    if (!organization) throw notFound();
    return { title: organization.name, organization };
  },
  component: () => <Outlet />,
});
